import React from 'react'

import UserUpdateForm from '@components/UserUpdateForm'

import V2Layout from '../V2Layout'
import V2Stepper from '../V2Stepper'
import V2CartAside from '../V2CartAside'
import '../../../css/v2.css'

// Atualização cadastral no fluxo V2.
// DECISÃO DE ARQUITETURA: o formulário V1 (UserUpdateForm) é reusado por inteiro —
// são 26 regras (A-01..A-26) + endereço/CEP/frete (E-*) + fluxo de IE/Sintegra; reescrever
// a camada visual dropando regra é exatamente o risco que o plano proíbe. O wrapper
// `v2-uuf` aplica o design system por CSS sem tocar na lógica.
// O redirecionamento pós-salvar volta ao Resumo V2 via flag `smd_v2_flow` (bridge no form).

export default function V2Atualizacao() {
  sessionStorage.setItem('smd_v2_flow', '1')
  return (
    <V2Layout>
      <V2Stepper current={2} />
      <div className="v2-step-grid" style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 32px 110px', display: 'grid', gridTemplateColumns: '1fr 340px', gap: '40px', alignItems: 'start' }}>
        {/* Discovery: nome da etapa na língua do comprador — o título operacional do
            formulário V1 ("Atualização cadastral") é ocultado por CSS escopado (.v2-upd) */}
        <div className="v2-uuf v2-upd">
          <span className="v2-eyebrow">Etapa 3 de 5</span>
          <h1 style={{ margin: '8px 0 0', fontFamily: 'Poppins,sans-serif', fontWeight: '600', fontSize: '34px', lineHeight: '1.15', letterSpacing: '-0.7px', color: '#373535' }}>
            Seus dados
          </h1>
          <p style={{ margin: '12px 0 24px', maxWidth: '560px', fontSize: '16px', lineHeight: '1.6', color: '#6B6664' }}>
            Confirme ou atualize seus dados de contato e cobrança antes de finalizar.
          </p>
          <UserUpdateForm />
        </div>
        <V2CartAside />
      </div>
    </V2Layout>
  )
}
